// extracted by mini-css-extract-plugin
export default {"itemSeparator":"separator_itemSeparator__rTMvI","dotSeparator":"separator_dotSeparator__uEA3z"};